const Footer = () => {
    const year = new Date().getFullYear();

    return <footer>{`Copyright © 💙Made With Love❤️ ${year}`}</footer>;
};

export default Footer;